import { generateBooleanSchema, generateRootObjectSchema, generateColorSchema, generateStringSchema } from "components/cards/common/schema";
import { BaseParticleSpec, GetParticlePropsType, GetParticleSchemaType, generateParticleContainerSchema } from "components/cards/particles/BaseParticleSpec";
import { TextParticleSpec } from "../Text/spec";

export const FormTextAreaParticleSpec = new BaseParticleSpec("Form Text Area Input", generateRootObjectSchema({
    container: generateParticleContainerSchema(),
    backgroundColor: generateColorSchema("Background Color", "The color of the background within the textarea.", {
      defaultValue: "white"
    }),
    errorColor: generateColorSchema("Error Color", "The color of the error highlighting.", {
      defaultValue: "#ff4800"
    }),
    labelText: TextParticleSpec.generateSchema("Label", "Any specified text becomes the label for the text area.", {
      defaultValues: { text: "Label", color: "#949494" }
    }),
    placeholderText: TextParticleSpec.generateSchema("Placeholder Text", "Any specified text becomes the placeholder for the text area.", {
      defaultValues: { text: "Placeholder", color: "#949494" }
    }),
    inputText: TextParticleSpec.generateSchema("Input Text", "The text styling for the text area input.", {
      defaultValues: { color: "black" }
    }),
    minHeight: generateStringSchema("Text Area Minimum Height", "The minimum height of the text area in pixels.", {
      defaultValue: "120px"
    }),
    required: generateBooleanSchema("Required Input", "Indicates that this input is required.", {
      defaultValue: false
    }),
    isAnimated: generateBooleanSchema("Animated Labels", "Animate Label Text.", {
      defaultValue: true
    }),
    showPlaceholder: generateBooleanSchema("Show Placeholder", "Show Placeholder Text.", {
      defaultValue: true
    }),
}));

export const specification = FormTextAreaParticleSpec;

export type FormTextAreaParticleSchema = GetParticleSchemaType<typeof FormTextAreaParticleSpec>;

export type FormTextAreaParticleProps = GetParticlePropsType<typeof FormTextAreaParticleSpec>;
